import { render, staticRenderFns } from "./ProductBuy.vue?vue&type=template&id=44db3b53&scoped=true&"
import script from "./ProductBuy.vue?vue&type=script&lang=js&"
export * from "./ProductBuy.vue?vue&type=script&lang=js&"
import style0 from "./ProductBuy.vue?vue&type=style&index=0&id=44db3b53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db3b53",
  null
  
)

export default component.exports